import { jsx as _jsx } from "react/jsx-runtime";
import { Button as BaseButton } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import Button from "../atoms/Button";
const DatePeriodStepper = ({ period, onPeriodChange, size = "sm", periods, }) => {
    const { t } = useTranslation();
    const byPeriods = {
        day: t("days"),
        week: t("weeks"),
        month: t("months"),
    };
    return (_jsx(BaseButton.Group, Object.assign({ width: "full", isAttached: true, colorScheme: "green", mx: {
            base: "auto",
            md: 0,
        }, size: size }, { children: (periods !== null && periods !== void 0 ? periods : ["day", "week", "month"]).map((_period) => (_jsx(Button, Object.assign({ flex: 1, onPress: () => onPeriodChange(_period), variant: _period === period ? "primary" : "outlined" }, { children: byPeriods[_period] }), `date-scope-stepper-${_period}`))) })));
};
export default DatePeriodStepper;
